import * as React from "react";

const CartIcon: React.FC = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.72699 24.454C10.3295 24.454 10.818 23.9656 10.818 23.363C10.818 22.7605 10.3295 22.272 9.72699 22.272C9.12444 22.272 8.63599 22.7605 8.63599 23.363C8.63599 23.9656 9.12444 24.454 9.72699 24.454Z"
                stroke="#1C355E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.727 24.454C22.3295 24.454 22.818 23.9656 22.818 23.363C22.818 22.7605 22.3295 22.272 21.727 22.272C21.1244 22.272 20.636 22.7605 20.636 23.363C20.636 23.9656 21.1244 24.454 21.727 24.454Z"
                stroke="#1C355E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1 1.54504H5.364L8.287 16.154C8.38667 16.6564 8.65988 17.1077 9.0588 17.429C9.45772 17.7502 9.95692 17.9208 10.469 17.911H21.069C21.5816 17.9217 22.0817 17.7515 22.4812 17.4302C22.8808 17.1089 23.1544 16.657 23.254 16.154L25 7.00104H6.454"
                stroke="#1C355E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(CartIcon);
